module.exports = __webpack_public_path__ + "media/images/icons/hammer2x-71671b0759742e02a9e329afa33d3245.png";